import { Card, Row } from "antd";
import EmptyHeaderHero from "../EmptyHeaderHero";
import Styles from './Styles.module.css'
import { createContext, useEffect, useMemo, useState } from "react";
import CallDistributionOptInView from "./Views/CallDistributionOptInView";
import CallDistributionOptOutView from "./Views/CallDistributionOptOutView";
import TargetedAdsOptOutView from "./Views/TargetedAdsOptOutView";
import TargetedAdsOptInView from "./Views/TargetedAdsOptInView";

export const UserDataPreferenceContext = createContext(null);

function getViewNameFromLocation() {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search);
  return (params.get("v") || "").toLowerCase();
}

export default function UserDataPreferences() {
  const [title, setTitle] = useState("");
  const [resultMessage, setResultMessage] = useState("");
  const [viewName, setViewName] = useState("");

  useEffect(() => {
    setViewName(getViewNameFromLocation());
  }, []);

  const view = useMemo(() => {
    switch (viewName) {
      case "call-dist-opt-in":
        return <CallDistributionOptInView />;
      case "targeted-ads-opt-out":
        return <TargetedAdsOptOutView />;
      case "targeted-ads-opt-in":
        return <TargetedAdsOptInView />;
      default:
        return <CallDistributionOptOutView />;
    }
  }, [viewName]);

  return (
    <>
      <UserDataPreferenceContext.Provider value={{setTitle, setResultMessage}}>
        <EmptyHeaderHero title={title} minHeight={true}/>
        <div className={`${Styles["optout-screen"]}`}>
          <Row>
            <Card className={`${Styles["optout-card"]}`}>
              {resultMessage ? <p>{resultMessage}</p> : view}
            </Card>
          </Row>
        </div>
      </UserDataPreferenceContext.Provider>
    </>
  )
}